'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import SideMenu from '../components/sideMenu';
import NavBar from '../components/navBar';
import menuAction from '../actions/menuAction';
import LeaveSetForm from './leaveSetComponents/leaveSetForm';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import leaveSetAction from '../actions/leaveSetAction';
import leaveSetStore from '../stores/leaveSetStore';
import Loading from '../components/loading';
import LeaveSetBody from './leaveSetComponents/leaveSetBody';
import LeaveSetHeader from './leaveSetComponents/leaveSetHeader';


class LeaveSetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,
            processing: leaveSetStore.getState().processing,
            search: leaveSetStore.getState().search,
            staffId: leaveSetStore.getState().staffId,
            updating: leaveSetStore.getState().updating,
            userName: leaveSetStore.getState().userName,
            modalClose: false,
        };
    }

    componentDidMount() {
        leaveSetStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        menuAction.pageNumber(13);
        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing.defer(true);
            filterAction.getEmployee.defer();
        }
    }

    componentWillUnmount() {
        leaveSetStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
   

    shouldModalClose(data) {
        this.setState({ modalClose: data });
    }

    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
        });
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            search: state.search,
            staffId: state.staffId,
            updating: state.updating,
            userName: state.userName,
        });
    }
    render() {
        let body = '';

        if (this.state.updating) {
            body = <LeaveSetForm staffId={this.state.staffId} userName={this.state.userName} processing={this.state.processing} />
        } else {
            let staffs;
            if (this.state.staffs.length > 0) {
                staffs = this.state.staffs.filter((staff) => {
                    return (
                        staff.userName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 ||
                        staff.staffId.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1
                    );
                });
            }

            body = <LeaveSetBody staffs={staffs} />
        }

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <LeaveSetHeader staffs={this.state.staffs} processing={this.state.processing} />
                        <div className="divider"></div>
                        {body}
                    </div>
                </div>
                
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default LeaveSetting;


// WEBPACK FOOTER //
// ./app/setComponents/leaveSetting.js